export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10145.01937bd5.jpg";